import { useEffect } from "react";

const BASE_URL = "https://mynami.cn";

interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalPath?: string;
  ogType?: string;
  jsonLd?: Record<string, unknown>[];
}

const setMeta = (attr: "name" | "property", key: string, content: string) => {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel: string, href: string) => {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export default function Seo({
  title,
  description,
  keywords,
  canonicalPath = "/",
  ogType = "website",
  jsonLd = [],
}: SeoProps) {
  useEffect(() => {
    const canonical = `${BASE_URL}${canonicalPath}`;
    document.title = title;
    setMeta("name", "description", description);
    if (keywords) {
      setMeta("name", "keywords", keywords);
    }
    setMeta("name", "robots", "index,follow");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", ogType);
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:site_name", "黑料每日");
    setMeta("property", "og:locale", "zh_CN");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setLink("canonical", canonical);

    const scriptId = "readdy-page-jsonld";
    const existing = document.getElementById(scriptId);
    if (existing) {
      existing.remove();
    }
    if (jsonLd.length > 0) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = scriptId;
      script.textContent = JSON.stringify(
        jsonLd.length === 1 ? jsonLd[0] : jsonLd,
      );
      document.head.appendChild(script);
    }
  }, [title, description, keywords, canonicalPath, ogType, jsonLd]);

  return null;
}